// import React from 'react';
// import { Select as SelectAntd, SelectProps } from 'antd';

import styled from 'styled-components';
import React from 'react';
import { Badge } from 'antd';

export interface TabOptions {
  values: Array<string>;
  selectedIndex: number;
  onTabPress: (val: number) => void;
  badges?: Array<number>;
}

const TabWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const TabItem = styled.div<{ isSelected: boolean }>`
  font-size: 26px;
  font-family: 'Roboto400';
  width: 100%;
  cursor: pointer;
  padding-top: 5px;
  padding-bottom: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: ${({ isSelected }) => (isSelected ? '#000' : '#6F7072')};
  border-bottom: ${({ isSelected }) => (isSelected ? '6px solid #C21B17' : 'none')};
  background-color: #fff;
  border-right: ${({ isSelected }) => (isSelected ? 'none' : 'none')};
  border-left: ${({ isSelected }) => (isSelected ? 'none' : 'none')};

  @media (max-width: 480px) {
    font-size: 17px;
  }
`;

function Tab({ values, selectedIndex, onTabPress, badges }: TabOptions) {
  return (
    <TabWrapper>
      {values?.map((item, index) => {
        return (
          <TabItem
            key={item}
            isSelected={selectedIndex === index}
            onClick={() => onTabPress(index)}
            style={{
              borderRight: index === 0 && selectedIndex === 0 ? '#B1B2B4' : 'none',
              borderLeft: index === 1 && selectedIndex === 1 ? '#B1B2B4' : 'none',
            }}
          >
            {badges && badges[index] !== undefined && <Badge count={badges[index]}></Badge>}
            {item}
          </TabItem>
        );
      })}
    </TabWrapper>
  );
}

export default Tab;
